import initSlider from '../libs/initSlider';
import changeActiveSlide from '../changeActiveSlide';
import loadYoutubeScript from '../libs/loadYoutubeScript';
import { tabsSliderOptions, tabsContentSliderOptions } from '../sliders/sliders';

document.addEventListener('DOMContentLoaded', (e) => {
  loadYoutubeScript();

  const PAGE = 'modules';

  /*  */

  const featuresTabsSlider = initSlider('[data-features-tabs-slider]', {
    ...tabsSliderOptions,
    centeredSlides: false,
  });
  const featuresSlider = initSlider('[data-features-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: featuresTabsSlider,
      autoScrollOffset: 0.5,
    },
  });

  /*  */

  const modulesTabsSlider = initSlider('[data-modules-tabs-slider]', tabsSliderOptions);
  const modulesSlider = initSlider('[data-modules-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: modulesTabsSlider,
      autoScrollOffset: 0.5,
    },
  });

  modulesTabsSlider.on('click', (swiper) => {
    changeActiveSlide(swiper, PAGE);
  });
  modulesSlider.on('slideChangeTransitionStart', (swiper) => {
    changeActiveSlide(swiper, PAGE);
  });
});
